import React, { useEffect, useState } from 'react'
import './Home.scss'
import logo from './../../Assets/Image/MINTPAGELOGO.png'
import ConnectModal from './ConnectModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import Web3 from 'web3';
import { checkNetwork, DisconnectMetaMask, getCurrentProvider, getMetamaskUser, getPrice, metaMaskProvider, mint, saleStatus, switchNetwork, totalSupply } from '../../module/action/user-task';
import { useDispatch, useSelector } from 'react-redux'
import { proofFun } from '../../web3/merkle_root';
import MintModals from './MintModal';
import { useWeb3React } from '@web3-react/core';

function Home({getLibrary}) {
    const { active, account, error, activate, deactivate,library } = useWeb3React()
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showMint, setShowMint] = useState(false);

    const handleCloseMint = () => setShowMint(false);
    const handleShowMint = () => setShowMint(true);

    const [day, setDay] = useState(0)
    const [hours, setHours] = useState(0)
    const [mint, setMint] = useState(0)
    const [seconds, setSeconds] = useState(0)
    const dispatch = useDispatch()

    const [paymentMethod, setPaymentMethod] = useState('eth')
   
    const mintPrice = useSelector((e) => e.User.mintPrice)
    const metaMaskAccount = useSelector(e => e.User.metaMaskAccount)
    const connectionType = useSelector(e => e.User.connectionType)
    const username = useSelector(e => e.User.username)
    const mintLoader = useSelector(e => e.User.mintLoader)
    const calcTime = (city, offset, date) => {

        // create Date object for current location
        let d = new Date(date);

        // convert to msec
        // add local time zone offset
        // get UTC time in msec
        let utc = d.getTime() + (d.getTimezoneOffset() * 60000);

        // create new Date object for different city
        // using supplied offset
        let nd = new Date(utc + (3600000 * offset));

        // return time as a string
        return nd;

    }

    // useEffect(()=>{
    //     console.log(library,'library')
    //     dispatch(totalSupply(library))
    // },[library])
  
    useEffect(() => {
        console.log(library,'library')
        dispatch(checkNetwork())
        dispatch(saleStatus())
        dispatch(totalSupply())
        const checkConnection = async () => {

            // Check if browser is running Metamask
            let web3;
            if (window.ethereum) {
                web3 = new Web3(window.ethereum);
            } else if (window.web3) {
                web3 = new Web3(window.web3.currentProvider);
            };

            // Check if User is already connected by retrieving the accounts
            web3.eth.getAccounts()
                .then(async (addr) => {
                    dispatch(getMetamaskUser())
                    dispatch(getPrice())
                    // Set User account into state
                });
        };
        checkConnection();



        let refreshDelayMs = 1000

        function dhm() {
            let endDate = new Date(calcTime('utc', '+0', new Date('Sat Feb 21 2023 14:00:00 GMT+0500 (Pakistan Standard Time)'))).getTime()
            // let endDate = new Date(calcTime('utc', '+0', new Date('Sat Jan 31 2023 10:46:00 GMT+0500 (Pakistan Standard Time)'))).getTime()
            let nowDate = new Date(calcTime('utc', '+0', new Date())).getTime()
            let t = endDate - nowDate
            let cd = 24 * 60 * 60 * 1000;
            let ch = 60 * 60 * 1000;
            let cm = 60 * 1000;
            let cs = 1000;
            let d = Math.floor(t / cd);
            let h = Math.floor((t - d * cd) / ch);
            let m = Math.round((t - d * cd - h * ch) / cm);
            let s = Math.round((t - d * cd - h * ch - m * cm) / cs);
            let pad = function (n) { return n < 10 ? '0' + n : n; };
            // if (m === 0) {
            //     h--;
            //     m = 60;
            // }
            // if (h === 0) {
            //     d--;
            //     h = 24;
            // }
            // // if(s < 0)
            // if (s <= 0) {
            //     let passedSec = s
            //     m--;
            //     s = 60 + passedSec
            // }
            if (Number(d) < 0) {
                setDay(0)
            } else {
                if (Number(d) >= 0) setDay(Number(d))

            }
            if (Number(h) < 0) {
                setHours(0)
            } else {

                if (Number(d) >= 0) setHours(Number(h))
            }
            if (Number(m) < 0) {
                setMint(0)
            } else {

                if (Number(d) >= 0) setMint(Number(m))
            }
            if (Number(s) < 0) {
                setSeconds(0)
            } else {
                if (Number(d) >= 0) setSeconds(Number(s))

            }

            setTimeout(dhm, refreshDelayMs)
            // if (Number(d) > 0 &&
            //     Number(h) > 0 &&
            //     Number(m) > 0 &&
            //     Number(s) > 0
            // ) {
            // }
        }

        dhm()




    }, []);


    useEffect(() => {
        (async () => {
            if (!window.ethereum) {
                return;
            }
            let accountNumber;
            const accountWasChanged = (accounts) => {
                if (!accounts[0]) {
                    dispatch(DisconnectMetaMask());
                }
            };
            const metaProvider = await getCurrentProvider();
            metaProvider.on("accountsChanged", accountWasChanged);
            // metaProvider.on("chainChanged", chainChange);

            return () => {
                // if(metaProvider){
                metaProvider.off("accountsChanged", accountWasChanged);
                //   metaProvider.off("chainChanged", chainChange);
                // }
            }
        })()
    }, []);


    useEffect(() => {
    }, [day, hours, mint, seconds])



    return (
        <div className='Home'>
            <div className='innerHome'>
                <div className='formConnect'>
                    {metaMaskAccount ?

                        <div className='disconnectButton' onClick={() => {
                            dispatch(DisconnectMetaMask())
                        }}>
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"></path></svg>
                        </div>
                        : null}
                    <div class="logo">
                        <img width="252px" src={logo} />
                    </div>
                    <div class="divider" style={{ backgroundColor: `rgb(255, 255, 255)` }}>
                    </div>
                    <h1>
                        Mint a <br /> Sisters of Saturn</h1>
                    {metaMaskAccount ?
                        <>
                            {/* {day > 0 || hours > 0 || mint > 0 || seconds > 0 ?
                                <>
                                    <div className='mintButton'>
                                        <button disabled class="connectButton btn btn-primary btn-lg" style={{ cursor: "pointer" }} onClick={handleShowMint}>

                                            Mint
                                        </button>
                                    </div>
                                </>
                                : */}
                                <div className='mintButton'>

                                    <>
                                        {
                                            metaMaskAccount && proofFun(metaMaskAccount)[0] ?
                                                <button class="connectButton btn btn-primary btn-lg" style={{ cursor: "pointer" }} onClick={handleShowMint}>

                                                    Mint
                                                </button>
                                                :
                                                <div className='BUTTONSEPARATEDISABLE'>
                                                    <p>You are not Whitelisted</p>
                                                    <button disabled class="connectButton btn btn-primary btn-lg">

                                                        {/* <img src={BUTTONSEPARATEDISABLE} /> */}
                                                        Mint

                                                    </button>
                                                </div>

                                        }
                                    </>
                                </div>
                             {/* } */}
                        </>

                        :
                        <div className='mintButton'>
                            <div style={{ marginBottom: "30px" }}>
                                <p>
                                    What payment method will you use?</p>
                                <div class="input-group">
                                    <div class="form-check">
                                        <input name="paymentMethod" type="radio" id="ETH" defaultChecked="true" onChange={(ev) => {
                                            setPaymentMethod('eth')
                                        }} />
                                        <label title="" for="ETH" class="form-check-label">
                                            ETH</label>
                                    </div>
                                    {/* <div class="form-check">
                                        <input name="paymentMethod" type="radio" id="USD" onChange={(ev) => {
                                            setPaymentMethod('usd')
                                        }} />
                                        <label title="" for="USD" class="form-check-label">
                                            USD</label>
                                    </div> */}
                                </div>
                            </div>
                            <button type="button" class="connectButton btn btn-primary btn-lg" onClick={handleShow}>
                                Connect</button>
                        </div>

                    }
                </div>
            </div>
            <ConnectModal
                show={show}
                setShow={setShow}
                handleClose={handleClose}
                handleShow={handleShow}
            />
            <MintModals
                show={showMint}
                setShow={setShowMint}
                handleClose={handleCloseMint}
                handleShow={handleShowMint}
            />
        </div>
    )
}

export default Home

